import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import WithImpressions from '../../../WithImpressions';
import { biHelper } from '../../biHelper';
import './style.scss';

export default function Description({ description = null, biData }) {
    if (!description) { return null; }

    const seller_card_about_me_description_impression = biHelper({
        ...biData,
        group: 'seller_card_about_me_description_impression',
        data: description
    });

    return (
        <WithImpressions value={seller_card_about_me_description_impression} className="description">
            <h3><I18n k="user_page_perseus.seller_profile.description"/></h3>
            <p>{description}</p>
        </WithImpressions>
    );
}

Description.propTypes = {
    description: PropTypes.string,
    biData: PropTypes.object
};

Description.defaultProps = {
    description: '',
    biData: {}
};
